import { useIsCurrentUserMerchant } from "Hooks/useIsCurrentUserMerchant";
import { Bank } from "Infrastructure/Api/Api";
import {
  type ExistsFunction,
  type TFunction,
  Resources,
  useResource,
} from "Translations/Resources";

export const compareBanksByRating = (
  a: Bank,
  b: Bank,
  t: TFunction,
  exists: ExistsFunction,
  isMerchant: boolean,
) => {
  if (!isMerchant) {
    const isNotRecommendedA = exists(
      Resources.BankRating.Banks[a].NotRecommended?.Reason,
    );
    const isNotRecommendedB = exists(
      Resources.BankRating.Banks[b].NotRecommended?.Reason,
    );

    if (isNotRecommendedA !== isNotRecommendedB) {
      return isNotRecommendedA ? 1 : -1;
    }
  }

  const ratingA = Number(t(Resources.BankRating.Banks[a].Rating)) || 0;
  const ratingB = Number(t(Resources.BankRating.Banks[b].Rating)) || 0;

  if (ratingA === ratingB) {
    return a.localeCompare(b);
  }
  return ratingB - ratingA;
};

export const useSortedBanks = () => {
  const { t, exists } = useResource();
  const isMerchant = useIsCurrentUserMerchant();
  const bankKeys = Object.values(Bank);

  return bankKeys.sort((a, b) =>
    compareBanksByRating(a, b, t, exists, isMerchant),
  );
};
